import { render, staticRenderFns } from "./ChannelSubscriberButton.vue?vue&type=template&id=3b18c32e&scoped=true"
import script from "./ChannelSubscriberButton.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriberButton.vue?vue&type=script&lang=ts"
import style0 from "./ChannelSubscriberButton.vue?vue&type=style&index=0&id=3b18c32e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18c32e",
  null
  
)

export default component.exports